<template>
  <Form :reg.sync="reg"></Form>
</template>

<script>
export default {
  name: 'NewRegistrationForm',
  components: {
    Form: () => import('../../components/cloud/UserRegistration/Form.vue')
  },
  props: {
    reg: Object
  },
}
</script>

<style scoped>
</style>